// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "i.loverly-icon{align-items:center;display:inline-flex;height:1em;justify-content:center;overflow:visible;text-align:center;vertical-align:middle;width:1em}i.loverly-icon svg{height:100%;fill:currentColor}i.loverly-icon.height-fix svg{height:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
